import { render, staticRenderFns } from "./ManagerSummaryReportTab.vue?vue&type=template&id=29b270a6&scoped=true&"
import script from "./ManagerSummaryReportTab.vue?vue&type=script&lang=js&"
export * from "./ManagerSummaryReportTab.vue?vue&type=script&lang=js&"
import style0 from "./ManagerSummaryReportTab.vue?vue&type=style&index=0&id=29b270a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b270a6",
  null
  
)

export default component.exports